import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { flowRight } from 'lodash'
import { withTranslationCustom } from 'lib/i18next'
import { wrapEvent } from 'lib/utils/store/wrappers/event/Event'
import { withRouter } from 'react-router-dom'
import { EVENT_FORM_MODE } from 'components/Events/EventForm/EventForm'
import { getEventModalUrl } from 'lib/utils/store/event'

import AppContext from 'components/AppContext'
import Link from 'components/Link'
import Button from 'components/UI/Button'

import './vehicle-fuel-consumption-refills.pcss'

const VehicleFuelConsumptionRefills = ({ t, location, vehicleId, refillEvents, onBackToEdit }) => {
    return (
        <AppContext context="refills">
            <div className="vehicle-fuel-consumption-refills">
                <h3>{t('vehicles:fuelConsumption.refills')}</h3>
                <ul className="vehicle-fuel-consumption-refills__list">
                    {refillEvents.map((event, i) => {
                        const wrappedEvent = wrapEvent(event)

                        const dataMissing = !wrappedEvent.hasValuesForConsumptionCalculation()

                        const fuelAmountMissing = !wrappedEvent.getFuelAmount(false)
                        const fuelPriceMissing = !wrappedEvent.getFuelPrice(false)
                        const fuelTotalPriceMissing = !wrappedEvent.getFuelTotalPrice(false)

                        return (
                            <li
                                key={event.id}
                                className={classNames('vehicle-fuel-consumption-refills__list-item', {
                                    'vehicle-fuel-consumption-refills__list-item--data-missing': dataMissing,
                                })}
                            >
                                <span className="vehicle-fuel-consumption-refills__event-time">
                                    {wrappedEvent.getEventTime('DD.MM.YYYY HH:mm')}
                                </span>
                                <span className="vehicle-fuel-consumption-refills__data-fields">
                                    <span
                                        className={classNames('vehicle-fuel-consumption-refills__fuel-amount', {
                                            'vehicle-fuel-consumption-refills__fuel-amount--data-missing': fuelAmountMissing,
                                        })}
                                    >
                                        {wrappedEvent.getFuelAmount()}
                                    </span> {' / '}
                                    <span
                                        className={classNames('vehicle-fuel-consumption-refills__fuel-price', {
                                            'vehicle-fuel-consumption-refills__fuel-price--data-missing': fuelPriceMissing,
                                        })}
                                    >
                                        {wrappedEvent.getFuelPrice()}
                                    </span> {' / '}
                                    <span
                                        className={classNames('vehicle-fuel-consumption-refills__fuel-total-price', {
                                            'vehicle-fuel-consumption-refills__fuel-total-price--data-missing': fuelTotalPriceMissing,
                                        })}
                                    >
                                        {wrappedEvent.getFuelTotalPrice('- €')}
                                    </span>
                                </span>
                                {dataMissing && (
                                    <span className="vehicle-fuel-consumption-refills__fill-missing-data-link">
                                        {' ('}
                                        {(i === 0 && onBackToEdit) ? (
                                            <Button
                                                onClick={onBackToEdit}
                                                className="button button--plain"
                                                trackName="fillMissingData"
                                            >
                                                {t('vehicles:fuelConsumption.fillMissingData')}
                                            </Button>
                                        ) : (
                                            <Link
                                                to={getEventModalUrl(location, EVENT_FORM_MODE.EDIT, vehicleId, wrappedEvent.getId())}
                                                className="vehicle-fuel-consumption-refills__fill-missing-data-link"
                                                trackName="fillMissingData"
                                            >
                                                {t('vehicles:fuelConsumption.fillMissingData')}
                                            </Link>
                                        )}
                                        {')'}
                                    </span>
                                )}
                            </li>
                        )
                    })}
                </ul>
            </div>
        </AppContext>
    )
}

VehicleFuelConsumptionRefills.propTypes = {
    vehicleId: PropTypes.string.isRequired,
    refillEvents: PropTypes.array.isRequired,
    onBackToEdit: PropTypes.func,
}

export default flowRight(
    withRouter,
    withTranslationCustom(['vehicles']),
)(VehicleFuelConsumptionRefills)
